import { useQuery } from "@tanstack/react-query";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { GrafanaEmbedFrame } from "@/components/grafana-embed";
import { Skeleton } from "@/components/ui/skeleton";
import { api } from "@/lib/api";
import { GRAFANA_EMBED_QUERY_OPTIONS } from "@/lib/grafana-embed-query";

export function ControllerDiagnosticsPanel({ deviceId }: { deviceId: string }): JSX.Element {
  const embedQuery = useQuery({
    queryKey: ["grafana-embed", "device-diagnostics", deviceId],
    queryFn: () => api.grafanaDiagnosticsEmbed(deviceId),
    enabled: Boolean(deviceId),
    ...GRAFANA_EMBED_QUERY_OPTIONS,
  });

  return (
    <Card>
      <CardHeader>
        <CardTitle>Device diagnostics</CardTitle>
        <p className="text-sm text-muted-foreground">
          Health and telemetry quality for this controller.
        </p>
      </CardHeader>
      <CardContent>
        {embedQuery.error ? <ErrorBanner error={embedQuery.error} /> : null}
        {!embedQuery.error && !embedQuery.isFetchedAfterMount ? (
          <Skeleton className="h-[calc(100vh-20rem)] min-h-[640px] w-full" />
        ) : !embedQuery.error && embedQuery.isFetchedAfterMount && embedQuery.data ? (
          <GrafanaEmbedFrame
            url={embedQuery.data.url}
            title="Device Diagnostics dashboard"
            onRetry={() => void embedQuery.refetch()}
          />
        ) : null}
      </CardContent>
    </Card>
  );
}

function ErrorBanner({ error }: { error: unknown }): JSX.Element {
  return (
    <div className="mb-6 rounded-md border border-destructive/40 bg-destructive/10 px-4 py-3 text-sm text-destructive">
      {error instanceof Error ? error.message : "Failed to load the diagnostics dashboard"}
    </div>
  );
}
